// extracted by mini-css-extract-plugin
module.exports = {"emptyTitle":"SectionsList_emptyTitle__2OqU1","emptyButton":"SectionsList_emptyButton__SXUCx"};